import { render, staticRenderFns } from "./MaterialsPanel.vue?vue&type=template&id=032e0460&scoped=true"
import script from "./MaterialsPanel.vue?vue&type=script&lang=js"
export * from "./MaterialsPanel.vue?vue&type=script&lang=js"
import style0 from "./MaterialsPanel.vue?vue&type=style&index=0&id=032e0460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032e0460",
  null
  
)

export default component.exports